// extracted by mini-css-extract-plugin
export default {"modalBackdrop":"HintModal_modalBackdrop__1XcKb","modalContent":"HintModal_modalContent__6o2M3","text":"HintModal_text__xGhnb","exitModal":"HintModal_exitModal__+SBgO"};